import { useCallback as n } from "react";
import { useIntl as o } from "react-intl";
function f() {
  const e = o();
  return n(
    (r, t) => {
      const s = r.replace(/[-_]/g, "_");
      return e.messages[s] ? e.formatMessage({ id: s }, t) : e.formatMessage({ id: r }, t);
    },
    [e]
  );
}
export {
  f as useTranslate
};
